import { render } from "./BoqItems.vue?vue&type=template&id=7d89b42a"
import script from "@/assets/boq/BoqItems.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqItems.js?vue&type=script&lang=js"

import "./BoqItems.vue?vue&type=style&index=0&id=7d89b42a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__